import { render, staticRenderFns } from "./BusinessOrderDetailsView.vue?vue&type=template&id=608b446a&"
import script from "./BusinessOrderDetailsView.vue?vue&type=script&lang=ts&"
export * from "./BusinessOrderDetailsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports